import React, { useEffect, useState } from 'react'
import RequestJoinmeetingModal from './RequestJoinMeetingModal';

const MeetingJoinRequestQueue = ({
    selectedCall,
    joinRequestList,
    setJoinRequestList,
    currentMeetingRef,
    sendApproveJoinMeetingMessage,
    sendDenyJoinMeetingMessage,
    atCapacity
}) => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleApprove = (user) => {
        sendApproveJoinMeetingMessage(currentMeetingRef.current.id, user.id)
        setJoinRequestList((prevUsers) => prevUsers.filter((_, i) => i !== currentIndex));
        setCurrentIndex(0);
    }


    const handleDeny = (user) => {
        sendDenyJoinMeetingMessage(currentMeetingRef.current.id, user.id)
        setJoinRequestList((prevUsers) => prevUsers.filter((_, i) => i !== currentIndex));
        setCurrentIndex(0);
    }

    useEffect(() => {
        if (!joinRequestList) {
            return
        }

        if (joinRequestList.length > 0) {
            setIsModalOpen(true)
        } else {
            setIsModalOpen(false)
        }

    }, [joinRequestList.length])

    return (
        isModalOpen && selectedCall &&
        <RequestJoinmeetingModal
            open={isModalOpen}
            user={joinRequestList[currentIndex]}
            handleApprove={handleApprove}
            handleDeny={handleDeny}
            atCapacity={atCapacity}
        />
    )
}

export default MeetingJoinRequestQueue